import { Button, Form, Input, Modal, Space, Typography } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import State from "../../../../State";
import intl from "../../../../utils/intl";
import * as actions from "./actions";
import messages from "./messages";
import FuelingProcessCancelEditState from "./state";

export const RightAligned = styled.div`
  text-align: right;
`;

const FuelingProcessCancelEdit: React.FC = () => {
  const state = useSelector<State, FuelingProcessCancelEditState>(
    (state) => state.processCancelEdit
  );

  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const cancelProcess = async () => {
    const description = await form.getFieldValue(["description"]);

    if (state.fuelingProcessId == null) {
      return;
    }

    if (!confirm(intl.formatMessage(messages.cancelConfirm))) {
      return;
    }

    dispatch(actions.cancelFuelingProcess(state.fuelingProcessId, description));
  };

  const onCancel = () => {
    dispatch(actions.hideFuelingProcessCancelEdit());
  };

  const getErrorMessageDescriptor = (code: string | null) => {
    switch (code) {
      case "rejected":
        return messages.errorCodeRejected;
      case "unacceptableStateTransition":
        return messages.errorCodeUnacceptableStateTransition;
      case "error":
        return messages.errorCodeError;
      default:
        return messages.errorCodeError;
    }
  };

  return (
    <Modal
      width={640}
      onCancel={onCancel}
      footer={null}
      destroyOnClose={false}
      afterClose={() => form.resetFields()}
      visible={state.isModalVisible}
    >
      <Typography.Title level={4}>
        {intl.formatMessage(messages.title)}
      </Typography.Title>
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        onFinish={cancelProcess}
      >
        <Form.Item
          label={intl.formatMessage(messages.description)}
          name="description"
        >
          <Input
            style={{ width: "100%" }}
            disabled={state.isSaving}
            placeholder={intl.formatMessage(messages.descriptionHint)}
          />
        </Form.Item>

        <Form.Item>
          <RightAligned>
            <Space>
              <Button
                id="saveCancelProcessBtn"
                type="primary"
                htmlType="submit"
                loading={state.isSaving}
                disabled={state.isSaving}
              >
                {!state.isSaving
                  ? `${intl.formatMessage(messages.cancelProcess)}*`
                  : `${intl.formatMessage(messages.canceling)}`}
              </Button>
              <Button onClick={onCancel} disabled={state.isSaving}>
                {intl.formatMessage(messages.close)}
              </Button>
            </Space>
          </RightAligned>
        </Form.Item>

        <Form.Item>
          <div>
            <Typography.Text type="secondary">
              *{intl.formatMessage(messages.eventualUpdateDescription)}
            </Typography.Text>
          </div>
          {state.saveErrorCode && (
            <Typography.Text type="danger">
              {intl.formatMessage(
                getErrorMessageDescriptor(state.saveErrorCode)
              )}
              : {state.saveErrorMessage}
            </Typography.Text>
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FuelingProcessCancelEdit;
